// Uploads canceled through an AbortSignal reject with an AbortError. Those are deliberate, so
// callers use this to tell them apart from upload failures that should be reported to the user.
export function isAbortError(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'AbortError';
}
